<template>
  <div class="full-page">
    <div class="wrapper wrapper-full-page">
      <div
        class="page-header header-filter"
        filter-color="black"
        :style="bgImage"
      >
        <div class="container md-offset">
					<router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
	data() {
		return {
			bgImage: {
        backgroundImage: "url(https://res.cloudinary.com/pixel-bucket/image/upload/v1577032131/etax/tax_payer_kyc58f.jpg)"
      }
		}
	}
};
</script>	
